export function useEnvironmentCheck () {
  const isTest = window.location.port === '8080'
  const isDev = window.location.hostname.includes('localhost')
  const isBeta = window.location.hostname.includes('beta.foodsharing')
  const isProd = window.location.hostname.includes('foodsharing') && !window.location.hostname.includes('beta')
  const isDotAt = window.location.hostname.includes('foodsharing.at')
  const isChrome = navigator.userAgent.includes('Chrome')
  const isSafari = !isChrome && navigator.userAgent.includes('Safari')
  const isInChat = window.location.pathname.startsWith('/msg')

  return {
    isTest,
    isDev,
    isBeta,
    isProd,
    isDotAt,
    isChrome,
    isSafari,
    isInChat,
  }
}
